<template>
  <transition>
    <div class="dashboard-card">
      <div class="card-header">
        <awesomeIcon icon="folder"/> Portefeuille #{{$parent.port}}
        <a style="float:right;cursor:pointer;" @click="editName=true">
          <awesomeIcon icon="edit"/>
        </a>
      </div>
      <div class="card-content" style='padding-top:30px;'>
        <div class="special-txt1" @click="editName=true" style="cursor:pointer;">
          {{currentPort.name ? '"'+currentPort.name+'"' : 'Huidige waarde'}}
        </div>
        <h1>&euro; {{formatPrice(sumBy($parent.positions, 'worth'), true)}}</h1>
        <span class="grey">
          Bijgewerkt op {{(new Date($parent.positions[0].date)).toLocaleDateString()}}
          <span v-if="notUpToDate" @click="update=true" style="color: #d9534f; cursor: pointer;">
            <awesomeIcon icon="exclamation-circle"/>
          </span>
        </span>
        <template v-if="currentPort.cashflow.length > 0">
          <br><br><br>
          <div class="special-txt1" v-if="currentPort.cashflow[0].interval=='M'">
            Maandelijkse {{ !currentPort.target > 0 ? 'inleg' : 'mutaties'}}
          </div>
          <div class="special-txt1" v-if="currentPort.cashflow[0].interval=='Y'">
            Jaarlijkse {{ !currentPort.target > 0 ? 'inleg' : 'mutaties'}}
          </div>
          <div class="special-txt1" v-if="currentPort.cashflow[0].interval=='H'">
            Halfjaar {{ !currentPort.target > 0 ? 'inleg' : 'mutaties'}}
          </div>
          <div class="special-txt1" v-if="currentPort.cashflow[0].interval=='Q'">
            Kwartaal {{ !currentPort.target > 0 ? 'inleg' : 'mutaties'}}
          </div>
          <h1>&euro; {{formatPrice(currentPort.cashflow[0].value, true)}}</h1>
          <template v-if='!currentPort.target > 0'>
            <span
              v-if="noCashflow && !currentPort.cashflow[0].collect"
              @click="deposit=true" style="color: #d9534f; cursor: pointer;"
            >
            <awesomeIcon icon="exclamation-circle"/> Nog niet gestort {{currentPort.target}}
            </span>
            <span v-else-if="currentPort.cashflow[0].collect" @click="deposit=true" class="grey">
              Wordt automatisch gestort
            </span>
            <span v-else class="grey">
              Laatste storting {{(new Date(lastDeposit.date)).toLocaleDateString()}}
            </span>
          </template>
        </template>
      </div>
      <div class="card-bottom">
        <a
          v-if="iban || brand === 'OXBY'"
          class="button secondary" style="float:left;"
          @click="deposit=true"
        >
          <awesomeIcon icon="wallet"/> Bijstorten
        </a>
        <a class="button secondary" @click="$parent.clickDetails('new_class')">
          Alle posities <awesomeIcon icon="chart-line"/>
        </a>
      </div>

      <modalWindow
        v-if="deposit && currentPort.brand === 'OXBY'"
        @close="deposit=false;pick=null"
      >
        <div class="titlebar">Bijstorten</div>
        <div class="form-error" style="padding:10px 20px;" v-if="amount < 1">
          Geen geldig bedrag.
        </div>
        <div style="padding:20px;" v-if="!bankSelect && !pick">
          <customInput v-model="amount" type="money" label="Bedrag"/>
          <p class="msg" style="margin: 5px;" v-if="amount > 999">
            Let op: Wanneer u via iDeal een hoog geldbedrag overboekt, kan afhankelijk van de bank
            een maximum gelden.
          </p>
          <button @click="bankSelect=true" style="width:100%;margin-top:10px;">
            Overmaken
          </button>
        </div>
        <div v-if="bankSelect && !pick">
          <div style="padding:20px;">
            <span v-if="msg" class="msg">
              <awesomeIcon icon="exclamation-circle" />
              <span>
                {{ msg }}
              </span>
            </span>
            Stort alleen vanuit uw vaste tegenrekening!<br><br>
            <span v-if="currentPort.contra" style="font-size: larger">
              {{currentPort.contra.replace(new RegExp('_', 'g'), '*')}}<br><br>
            </span>
            <form @submit.prevent>
              <select v-model="selected">
                <option v-for="issuer in issuers" :key="issuer.id" :value="issuer.id">
                  {{issuer.name}}
                </option>
              </select>
              <button
                v-if="!pick"
                @click="newIdeal(selected)"
                style="width:100%; margin-top:10px;"
              >
                iDeal betaling
              </button>
              <button
                v-if="!pick"
                @click="pick='bank'"
                style="width:100%;margin-top:10px;"
              >
                Bank overschrijving
              </button>
            </form>
          </div>
          <a class="block-button" @click="bankSelect=!bankSelect">
            <awesomeIcon icon="chevron-left"/> Terug
          </a>
        </div>
        <template v-if="pick=='bank'">
          <div style="padding:20px;">
            U kunt een geldbedrag op uw beleggingsrekening bijstorten via onderstaand IBAN-nummer.
            Vermeld in de omschrijving uw portefeuillenummer.<br>
            <br>
            <table>
              <tr style="background-color:#fff;">
                <th>IBAN</th><td>NL 85 ABNA 042 619 8212</td>
              </tr>
              <tr style="background-color:#fff;">
                <th>Tenaamstelling</th><td>Stichting Collectieve Beleggersgiro</td>
              </tr>
              <tr><th>Portefeuille</th><td>{{$parent.port}}</td></tr>
            </table>
          </div>
          <a class="block-button" @click="pick=!pick">
            <awesomeIcon icon="chevron-left"/> Terug
          </a>
        </template>
      </modalWindow>

      <modalWindow
        v-else-if="deposit && currentPort.brand !== 'OXBY'"
        @close="deposit=false"
      >
        <div class="titlebar">Bijstorten</div>
        <div style="padding:20px;">
          U kunt een geldbedrag op uw beleggingsrekening bijstorten via onderstaand IBAN-nummer.
          Vermeld in de omschrijving uw portefeuillenummer.
          <br>
          <br>
          <table>
            <tr style="background-color:#fff;">
                <th>IBAN</th><td><b>{{iban}}</b></td>
            </tr>
            <tr style="background-color:#fff;">
              <th>Tenaamstelling</th>
              <td v-if="currentPort.bank === 'GILI'">InsingerGilissen</td>
              <td v-else><i>Uw eigen naam</i></td>
            </tr>
            <tr>
              <th>Portefeuille</th><td>{{$parent.port}}</td>
            </tr>
          </table>
        </div>
      </modalWindow>
      <modalWindow v-if="update" @close="update=false">
        <div class="titlebar">Gegevens nog niet bijgewerkt.</div>
        <div class="inset">
          Benodigde data, van bijvoorbeeld de depotbank, is nog niet ontvangen.<br><br>
          Dit kan gebeuren na feestdagen, dan ontvangen wij geen nieuwe data.<br><br>
          Maar ook door een storing,
          dan doen we er uiteraard alles aan dit zo snel mogelijk op te lossen.
        </div>
      </modalWindow>

      <modalWindow v-if="editName" @close="editName=false">
        <div class="titlebar">Portefeuille naam</div>
        <form @submit.prevent class="inset">
          <input
            type=text ref="name" :value="currentPort.name"
            placeholder="Naam (max. 25 karakters)" maxlength="25"
          >
          <input type=submit @click="updateName" value="Aanpassen">
        </form>
      </modalWindow>

    </div>
  </transition>
</template>

<script>
import {
  sumBy,
  find,
  findIndex,
  filter,
} from 'lodash-es';

export default {
  name: 'TotalsWidget',
  data() {
    return {
      update: false,
      deposit: false,
      pick: null,
      amount: '50',
      bankSelect: null,
      selected: null,
      editName: false,
      msg: '',
    };
  },
  props: {
    watch: Boolean,
  },
  created() {
    this.sdk.getIssuers((response) => {
      if (response.status === 200) {
        this.issuers = response.data;
        const found = this.currentPort.contra
          ? findIndex(this.issuers, (o) => o.id.includes(
            this.currentPort.contra.substr(4, 4),
          ))
          : 0;
        this.selected = response.data[found > 0 ? found : 0].id;
      }
    });
    if (this.currentPort.cashflow[0] && this.currentPort.cashflow[0].value) {
      this.amount = `${this.currentPort.cashflow[0].value}`;
    }
  },
  watch: {
    watch() {
      this.deposit = true;
    },
  },
  methods: {
    sumBy,
    newIdeal(issuer) {
      this.sdk.portNewIdeal(
        this.$store.state.currentPort,
        issuer,
        this.amount,
        (response) => {
          if (response.status === 200) {
            window.location.href = response.data;
          } else if (response.status === 429) {
            if (response.data.transactionTimeout === 'timeout') {
              this.msg = 'Te veel transactiepogingen in de laatste minuut, probeer het over een paar minuten nog eens.';
            } else if (response.data.transactionTimeout === 'ban') {
              this.msg = 'Te veel transactiepogingen in de laatste 12 uur, probeer het over 24 uur nog eens.';
            }
          }
        },
      );
    },
    updateName() {
      this.editName = false;
      find(this.$store.state.ports, {
        id: this.$store.state.currentPort,
      }).name = this.$refs.name.value;
      this.sdk.modifyPort(
        this.$store.state.currentPort,
        this.$refs.name.value,
        null,
        null,
        () => { },
      );
    },
  },
  computed: {
    currentPort() {
      return this.$parent.currentPort;
    },
    noCashflow() {
      if (!this.currentPort.cashflow[0]) {
        return false;
      }
      const date = new Date();
      date.setUTCHours(0);
      date.setUTCMinutes(0);
      date.setUTCSeconds(1);
      if (this.currentPort.cashflow[0].interval === 'M') {
        date.setUTCMonth(date.getUTCMonth() - 1);
      } else if (this.currentPort.cashflow[0].interval === 'Y') {
        date.setUTCFullYear(date.getUTCFullYear() - 1);
      } else {
        date.setUTCMonth(date.getUTCMonth() - 3);
      }
      const storting = find(
        filter(
          this.$parent.mutations,
          (o) => new Date(o.date) >= date
            && o.total >= this.currentPort.cashflow[0].value
            && !o.storno,
        ),
        {
          class: 'Storting',
        },
      );
      if (storting) {
        return false;
      }
      return true;
    },
    lastDeposit() {
      const date = new Date();
      date.setUTCHours(0);
      date.setUTCMinutes(0);
      date.setUTCSeconds(1);
      if (this.currentPort.cashflow[0].interval === 'M') {
        date.setUTCMonth(date.getUTCMonth() - 1);
      } else if (this.currentPort.cashflow[0].interval === 'Y') {
        date.setUTCFullYear(date.getUTCFullYear() - 1);
      } else {
        date.setUTCMonth(date.getUTCMonth() - 3);
      }
      return find(
        filter(
          this.$parent.mutations,
          (o) => new Date(o.date) >= date
            && o.total >= this.currentPort.cashflow[0].value
            && !o.storno,
        ),
        {
          class: 'Storting',
        },
      );
    },
    iban() {
      return this.currentPort.iban;
    },
    brand() {
      return this.currentPort.brand;
    },
    ports() {
      return this.$store.state.ports;
    },
    notUpToDate() {
      const now = new Date();
      const position = new Date(this.$parent.positions[0].date).toLocaleDateString();
      if (this.currentPort && now.toLocaleDateString() !== position && now.getUTCDay() !== 0) {
        if (this.currentPort.bank === 'BAL'
          || (now.getUTCDay() === 1 && this.currentPort.bank !== 'AAB')
          || (now.getUTCDay() === 6 && this.currentPort.bank === 'AAB')
        ) {
          return false;
        }
        return true;
      }
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
  .txtlink {
    margin: 20px;
    display: block;
    color: rgb(173, 173, 173);
  }
</style>
